module.exports = __webpack_public_path__ + "img/6.44545d86.png";